import React, { useState, useRef, useEffect } from 'react';

import { Button, Grid, Switch, Typography } from '@mui/material';
import { TCTitleLabel, TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import AssignmentComponent from './assignmentComponent';
import { AddCircleOutline } from '@mui/icons-material';

function AddAssignmentComponent({
    setAssignment,
    assignmentData = [],
    formId,
    merchantId,
    handleIsDefault,
}) {
    const [applyToAll, setApplyToAll] = useState(false)
    const [totalAssignment, setTotalAssignment] = useState([])
    const nextId = useRef(1)

    const saveAssignment = (e, index) => {
        let currData = totalAssignment[index]
        currData = {
            ...currData,
            ...e,
            _id: currData._id ? currData._id : '',
        }
        let newOps = totalAssignment;
        newOps.splice(index, 1, currData)
        setTotalAssignment(prev => (newOps))
        setAssignment({ assignments: newOps })
    }

    const addAssignment = () => {
        let newItem = {
            _id: nextId.current++,
            orderType: '',
            categoryId: '',
        }
        setTotalAssignment(prev => [...prev, newItem])
    }

    const deleteAssignment = (_id) => {
        let newOps = totalAssignment.filter((item) => item._id !== _id)
        setTotalAssignment(newOps)
        setAssignment({ assignments: newOps })
    }

    useEffect(() => {
        setTotalAssignment(assignmentData)
    }, [assignmentData]);

    //switch to apply to all change
    useEffect(() => {
        console.log('applyToAll', applyToAll)
    }, [applyToAll])

    return (
        <Grid container sx={{ px: 2, py: 1, border: '1px #ccc solid', borderRadius: 2 }}>
            <Grid xs={12} md={12} sx={{ py: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Grid item>
                    <TCLabel>Select all order types</TCLabel>
                </Grid>
                <Grid item>
                    <Switch
                        checked={applyToAll}
                        onChange={(e) => setApplyToAll(e.target.checked)}
                        name="sdm"
                        size="small"
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid display={"flex"} gap={1} alignContent={"center"} alignItems={"center"}>
                    {/* <TCTitleLabel>Assign To</TCTitleLabel>
                    <div display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{ cursor: "pointer" }} onClick={addAssignment}>
                        <AddCircleOutline />
                    </div> */}
                    <Button variant='contained' onClick={addAssignment} disabled={applyToAll}>
                        Add Assign To
                    </Button>
                </Grid>
            </Grid>
            {
                totalAssignment.map((value, index) => {
                    return <Grid item xs={12} style={{ padding: 4 }}>
                        <AssignmentComponent data={value} index={index} saveAssignment={saveAssignment} formId={formId} deleteAssignment={(index) => deleteAssignment(index)} isDefault={applyToAll} merchantId={merchantId} />
                    </Grid>
                })
            }
        </Grid>
    );
}

export default AddAssignmentComponent;